// extracted by mini-css-extract-plugin
module.exports = {"button":"upgrade-subscription-button_button__7zEtv"};